var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTags = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48363",
    "data-name": "Path 48363",
    d: "M85.824,104.772a1.432,1.432,0,0,0-1.472-1.543q-5.531-.009-11.063,0a1.4,1.4,0,0,0-1.156.537,1.611,1.611,0,0,0-.308,1.061q0,9.082,0,18.164v.233c.084-.047.138-.074.19-.106q3.315-2.034,6.628-4.072a.276.276,0,0,1,.338-.008q3.328,2.049,6.663,4.087c.052.032.106.059.18.1V108.562C85.825,107.3,85.827,106.035,85.824,104.772Zm-4.8,10.955-2.184-2.231-2.221,2.276-1.987-2.03,2.2-2.243-2.193-2.239,1.96-2,2.2,2.254,2.226-2.275,1.949,1.992-2.172,2.213,2.21,2.254Z",
    transform: "rotate(90 97.526 25.7)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTags);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_tags.6b4e96a93b4507a58473eab1af9d5b79.svg";